import { FileExtension } from '@rp/shared/models';

const FileUploaderTypes = {
  PDF: '.pdf',
  Word: ['.doc', '.docx'] as const,
  Image: ['.jpeg', '.jpg', '.png'] as const,
  Spreadsheet: ['.xls', '.xlsx'] as const,
  Csv: '.csv',
} as const;

const joinExtensions = (extensions: readonly string[]): string => extensions.join(',');

const DocumentFileTypes = {
  BasicDocs: joinExtensions([
    FileUploaderTypes.PDF,
    ...FileUploaderTypes.Word,
    FileUploaderTypes.Csv,
  ]),
  Images: joinExtensions(FileUploaderTypes.Image),
  Spreadsheets: joinExtensions(FileUploaderTypes.Spreadsheet),
} as const;

const DOCUMENT_FILE_TYPES: string = [
  DocumentFileTypes.BasicDocs,
  DocumentFileTypes.Images,
  DocumentFileTypes.Spreadsheets,
].join(',');

export const FileUploaderAcceptFileType = {
  DOCUMENT: DOCUMENT_FILE_TYPES,
  PDF: FileUploaderTypes.PDF,
  Csv: FileUploaderTypes.Csv,
  WORD: joinExtensions(FileUploaderTypes.Word),
  IMAGE: joinExtensions(FileUploaderTypes.Image),
  SPREADSHEET: joinExtensions(FileUploaderTypes.Spreadsheet),
} as const;

export const FilePreviewTypes = [FileExtension.Pdf, FileExtension.Jpeg, FileExtension.Png];
